import { takeLatest, put, call } from 'redux-saga/effects';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import { CATEGORY_MEDIA_GET } from '../actions/utils';
import utils from '../../api/utils';

function* categoryMediaGet({ id, filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      utils.categoryMediaGet,
      id,
      filters
    );
    yield put({ type: CATEGORY_MEDIA_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > utils > categoryMediaGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* categoryMediaGetWatch() {
  yield takeLatest(CATEGORY_MEDIA_GET._REQUEST, categoryMediaGet);
}

export default [categoryMediaGetWatch()];
